<template>
  <div class="hero-image">
  </div>
</template>

<script>
export default {
  name: "ContactSection1"
}
</script>


<style scoped>
body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

.hero-image {
  background-image: url("https://asset.hamdan.ae//CPDAssets/DefaultImages/NewsDefault.jpg?RenditionID=24");
  background-color: #cccccc;
  height: 600px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 4px 10px 0px;
}
</style>